import React, { Component } from 'react';

import { GenericOption } from 'com-gyf-webcore-userinterfacecomponents';
import TagUsuario from './TagUsuario';

let usersFound = undefined;
let userPropKeyLogin = "Login";
let userPropKeyNombre = "Nombre";
let keyWasPressed = false;

class ModalEstadosBusquedaUsuarios extends Component {
    constructor(props) {
        super(props);

        this.state = {
            textLogin: '',
            userFound: true,
            showErrorMessage: false
        }
    }

    onPasteText(e) {
        e.preventDefault();
        e.nativeEvent.stopImmediatePropagation();
    }


    addUser = (event) => {
        const { usuariosModalEstados, usuariosModalEstadosSeleccionado } = this.props;

        let term = event.target.value.toString().toLowerCase();
        let showErrorMessage = false;
        let usersFound = undefined;

        if (term != "") {
            showErrorMessage = true;
            term = term.replace("(", "").replace(")", "");

            usersFound = usuariosModalEstados.filter(x => (x.Nombre || "").toString().toLowerCase() == (term || "").toString().toLowerCase());
        }

        if (usersFound && usersFound.length == 1 && !keyWasPressed) {
            this.props.addUsuarioModalEstados(usersFound[0].Login);

            this.setState({ textLogin: usersFound[0].Nombre });
        }
        else {
            this.setState({ textLogin: event.target.value, userFound: (usersFound && usersFound.length > 0), showErrorMessage });
            this.props.addUsuarioModalEstados(undefined);
        }

        keyWasPressed = false;
    }

    keyDown = (event) => {
        //backspace = 8, tab = 9, enter = 13, ctrol = 17, shift = 16, alt = 18, [left = 37, up = 38, rigth = 39, down = 40] (flechas)
        //=> no se deben considerar como tecla presionada

        let keyNotAllowed = [8, 9, 13, 16, 17, 18, 37, 38, 39, 40];

        if (keyNotAllowed.indexOf(event.keyCode) < 0) {
            keyWasPressed = false;
        }
    }

    onFocus = (event) => {
        keyWasPressed = false;
    }

    onKeyPress = (event) => {
        let regExp = /[a-z0-9 ]/ig;

        if (!regExp.test(event.key)) {
            event.preventDefault();
        }
    }

    render() {
        const { usuariosModalEstados, usuariosModalEstadosSeleccionado } = this.props;
        let oUsersName = undefined;
        
        var oUsers = usuariosModalEstados.map(function (usuario) {
            return (
                <GenericOption id={usuario.Nombre} description={usuario.Nombre + " (" + usuario.Login + ")"} key={"Usuario_" + usuario.Id} />
            );
        });

        if (usuariosModalEstadosSeleccionado)
            oUsersName = <TagUsuario nombre={usuariosModalEstadosSeleccionado.Nombre} key={usuariosModalEstadosSeleccionado.Id} />

        return (
            <div>
                <input list="usersList" id="txtBusquedaNombreLogin"
                    className="textbox-rectangular form-control default-input top-separator-xxxs bottom-separator-xxs"
                    value={this.state.textLogin}
                    maxLength="40"
                    onChange={this.addUser}
                    onKeyDown={this.keyDown}
                    onFocus={this.onFocus}
                    onKeyPress={(e) => this.onKeyPress(e)}
                    onPaste={this.onPasteText}
                    placeholder="Ingrese nombre" />
                <input id="textUser" type="hidden" />
                <div className="row">
                    <div className="col-xs-6">
                        <datalist id="usersList">
                            {oUsers}
                        </datalist>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalEstadosBusquedaUsuarios;